export default __webpack_public_path__ + "static/media/TikiMirageBanner_small.882e6fda.png";